import EditInicio from "views/WebMaster/EditInicio";
import EditInstitucion from "views/WebMaster/EditInstitucion";
import EditGrafico from "views/WebMaster/EditGrafico";
import EditInterior from "views/WebMaster/EditInterior";
import EditModa from "views/WebMaster/EditModa";
import EditPublicidad from "views/WebMaster/EditPublicidad";
import EditIngreso from "views/WebMaster/EditIngreso";
import EditExtension from "views/WebMaster/EditExtension";
import EditEventos from "views/WebMaster/EditEventos";
import EditContacto from "views/WebMaster/EditContacto";

const WebMaster = [
    {
        path: "/edit_home",
        name: "Inicio",
        icon: "",
        component: EditInicio,
        color:"#424242"
    },
    {
        path: "/edit_institucion",
        name: "La Institución",
        icon: "",
        component: EditInstitucion,
        color:"#424242"
    },
    {
        path: "/edit_grafico",
        name: "Diseño Gráfico",
        icon: "",
        component: EditGrafico,
        color:"#424242"
    },
    {
        path: "/edit_interior",
        name: "Diseño Interior",
        icon: "",
        component: EditInterior,
        color:"#424242"
    },
    {
        path: "/edit_moda",
        name: "Diseño de Moda",
        icon: "",
        component: EditModa,
        color:"#424242"
    },
    {
        path: "/edit_publicidad",
        name: "Publicidad y Merc.",
        icon: "",
        component: EditPublicidad,
        color:"#424242"
    },
    {
        path: "/edit_ingreso",
        name: "Ingreso",
        icon: "",
        component: EditIngreso,
        color:"#424242"
    },
    {
        path: "/edit_extension",
        name: "Extensión",
        icon: "",
        component: EditExtension,
        color:"#424242"
    },
    {
        path: "/edit_eventos",
        name: "Eventos",
        icon: "",
        component: EditEventos,
        color:"#424242"
    },
    {
        path: "/edit_contacto",
        name: "Contacto",
        icon: "",
        component: EditContacto,
        color:"#424242"
    },
];
export default WebMaster;


// WEBPACK FOOTER //
// ./src/routes/WebMaster.jsx